import { ModuleWithProviders, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
//Components
import { BannerMainComponent } from '../../Shared/bannerMain.component';
import { MainComponent } from './main.component'
import {
  SharedModule, ButtonModule, DialogModule, InputTextModule, CalendarModule, ToolbarModule, ConfirmDialogModule, MessageModule, MessagesModule, DropdownModule
  //, , , RadioButtonModule, 
  //,  CheckboxModule, SelectButtonModule, InputTextareaModule,
  //ConfirmationService, MenubarModule

} from 'primeng';
import { FileUploadModule } from 'primeng/fileupload'
import { ConfirmationService } from 'primeng/api';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { OverviewComponent } from './overview/overview.component';
import { TestComponent } from './test/test.component';
import { ProjectListComponent } from './Lists/projectlist.component';
import { LinkTileComponent } from '../../Shared/link-tile/link-tile.component';


const homeRoutes: ModuleWithProviders = RouterModule.forChild([

  {
    path: 'home',
    component: MainComponent
   ,
    children: [
      { path: '', component: OverviewComponent },
      { path: 'ibkprojects', component: ProjectListComponent },
      { path: 'kpprojects', component: ProjectListComponent }
      //{ path: 'kontakt', component: ContactComponent, canActivate: [LoginGuard] },
      //{ path: 'auftraege', component: AuftraegeComponent, canActivate: [LoginGuard] },
      //{ path: 'oeffnungszeiten', component: OeffnungszeitenComponent, canActivate: [LoginGuard], canDeactivate: [CheckSaveGuard] },
      //{ path: 'shliesstage', component: SchliessTageComponent, canActivate: [LoginGuard] },
      //{ path: 'error', component: ErrorComponent },
    ]
  },
  //{
  //  path: '', redirectTo: '/home', pathMatch: 'full'
  //  //,canActivate: [InitGuard]
  //},

  { path: '**', redirectTo: '/home' }
]);


@NgModule({
  declarations: [
    MainComponent, BannerMainComponent, OverviewComponent, TestComponent, ProjectListComponent, LinkTileComponent
  ],
  imports: [homeRoutes, 
    BrowserModule, TableModule, TabViewModule, ButtonModule, DialogModule, InputTextModule, FormsModule,
    MultiSelectModule, CalendarModule, ToolbarModule, ConfirmDialogModule, MessageModule, MessagesModule,
    FileUploadModule, DropdownModule
  ],
  providers: [ConfirmationService],
  bootstrap: []
})
export class ProjectsModule { }
